module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery2_m.291e5e828d971dfb4611ccb33c472ddc.png";